import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCard = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M2.63 4.667a2 2 0 0 0-2 2v2h24v-2a2 2 0 0 0-2-2zm22 6.333h-24v7.668a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2zm-9 5.668a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCard);
export default Memo;
